const TrackFbq = (type, content) => {
    // const googleTagExists = typeof window.gtag === "function" || Array.isArray(window.dataLayer);

    // if (googleTagExists) {
    if (typeof window.fbq === "function") {
        window.fbq(type, content);
    } else {
        console.warn("Facebook Pixel not ready. Retrying...");

        const timeout = setTimeout(() => {
            if (typeof window.fbq === "function") {
                window.fbq(type, content);
            } else {
                console.error("Facebook Pixel still not available after delay.");
            }
        }, 1000);

        return () => clearTimeout(timeout);
    }
    // }
}

export default TrackFbq;